
function DateListController($scope, ModuleService) {

	var self = this;
	this.opened = false;
	this.selectedDates = [];
	this.currentDate = null;
	this.dateOptions = {
		closeOnDateSelection: false
	}
	
	/* from backreference */
	if (!$scope.object[$scope.field.name]) {
		$scope.object[$scope.field.name] = [];
	}
	self.items = $scope.object[$scope.field.name];
	//self.selectedDates = _.pluck(self.items, 'start_date');
	$scope.$watch('object[field.name]', function(items) {
		self.items = items;
		self.selectedDates = _.map(_.pluck(self.items, 'start_date'), function(date){return parseInt(moment(date).format('x'))});
		if (self.selectedDates.length > 0 && this.currentDate == null) {
			self.currentDate = moment(self.selectedDates[self.selectedDates.length - 1]).toDate()
		}
	});
	
	this.fetch_new = function(data) {
		var classname = $scope.field.join.foreignClass;
		var module = ModuleService.getModule(classname);
		module.addContext($scope.field.join.backref, $scope.object);
		return module.fetchNewObject().then(function(obj){
			if (typeof data == "object") obj.fill(data);
			return obj;
		});
	}
	
	this.remove = function(obj) {
		for (var i in self.items) {
			if (self.items[i] === obj) {
				self.items.splice(i, 1);
				break;
			}
		}
	}
	/* end from */

	this.open = function($event) {
		$event.preventDefault();
		$event.stopPropagation();
		console.log('open dates');
		self.opened = true;
	}
	
	$scope.$watchCollection(function(){return self.selectedDates;}, function(newdates, olddates) {
		var to_remove = [];
		// append new
		_.each(_.difference(newdates, olddates), function(datenum) {
			if (!datenum) return;
			var date = moment(datenum).format('YYYY-MM-DD')
			self.fetch_new({start_date: date}).then(function(obj){
				var i=0;
				for (i in self.items) {
					if (self.items[i].start_date > date) {
						self.items.splice(i, 0, obj);
						return;
					}
				}
				self.items.push(obj);
			});
		});
		// remove old
		_.each(_.difference(olddates, newdates), function(datenum) {
			if (!datenum) return;
			var date = moment(datenum).format('YYYY-MM-DD')
			var i=0;
			for (i in self.items) {
				if (self.items[i].start_date == date) self.items.splice(i, 1);
			}
		});
	});
	
	this.today = function(){
		self.currentDate = (new Date()).setHours(0, 0, 0, 0);
	}
	
	this.clear = function() {
		self.selectedDates = [];
	}

	window.dlCtrl = this;
}


angular.module('forms.fields.datelist', ['gm.datepickerMultiSelect'])
.controller('DateListController', DateListController)
